import Rectangle = createjs.Rectangle;

/**
 * Rich Text Link
 */
export class Link {
    public linkId: string;
    public rects: Rectangle[] = [];

    public constructor(ref: string, public isAnchorLink = false) {
        this.linkId = ref;
    }

    public startLinkRect(x: number, y: number) {
        this.rects.push(new Rectangle(x, y, 0, 0));
    }

    public endCurrentLinkRect(x: number, y: number) {
        const lastRect = this.rects[this.rects.length - 1];
        lastRect.right = x;
        lastRect.bottom = y;
    }

    public containsPoint(point: Point) {
        for (let rect of this.rects) {
            if (rect.containsPoint(point)) {
                return true;
            }
        }
        return false;
    }
}
